import { Button } from "@mui/material";
import clsx from "clsx";
import styles from "./LicenseInfoBanner.module.scss";
import {
  isLicenseExpired,
  formatEndDateRu,
} from "@src/widgets/TariffSection/lib/license";
import bulpImg from "@src/shared/assets/bulb_img.svg";

type Props = {
  endDate: string | null;
  isTrial: boolean;
  onExtend: () => void;
  onChooseTariff?: () => void;
};

export function LicenseInfoBanner({
  endDate,
  isTrial,
  onExtend,
  onChooseTariff,
}: Props) {
  if (!endDate) return null;

  const expired = isLicenseExpired(endDate);
  const dateText = formatEndDateRu(endDate);

  const cta =
    expired || isTrial
      ? { label: "Выбрать тариф", onClick: onChooseTariff }
      : { label: "Продлить", onClick: onExtend };

  return (
    <div
      className={clsx(styles.banner, expired && styles.bannerExpired)}
      role="note"
      aria-live="polite"
    >
      <div className={styles.left}>
        <div className={styles.wrapperImg}>
          <img src={bulpImg} />
        </div>
        <div className={styles.textContent}>
          <div className={styles.title}>
            {expired
              ? "Срок действия лицензии истёк "
              : "Срок действия лицензии истекает "}
            <span className={styles.date}>{dateText}</span>.
          </div>

          <div className={styles.subtitle}>
            {expired
              ? "Для продолжения работы выберите и оплатите тариф."
              : "Вы можете продлить текущий тариф или выбрать новый."}
          </div>
        </div>
      </div>

      <Button
        size="small"
        variant="contained"
        className={styles.cta}
        onClick={cta.onClick}
      >
        {cta.label}
      </Button>
    </div>
  );
}
